module.exports = __webpack_public_path__ + "media/youshould.1a263525.wav";